import ReportDocumento from 'components/core/ReportDocumento';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { generateAtestadoPdf } from './generateAtestadoPdf';

export default function ReportAtestado() {
  const location = useLocation();
  const { atestado, prontuario, medico } = location.state || {};
  const nomePaciente = atestado?.NOMEPAC || prontuario?.NOMEPAC || 'Paciente';

  const gerarBlob = useCallback(() => {
    return generateAtestadoPdf({ atestado, prontuario });
  }, [atestado, prontuario]);

  return (
    <ReportDocumento
      documento={atestado}
      gerarBlob={gerarBlob}
      fileName={`Atestado-Timbrado-Prevencor-${nomePaciente}-${Date.now()}.pdf`}
      titulo="Relatório do Atestado"
      nomePaciente={nomePaciente}
      iframeTitle="Atestado Prevencor"
      emptyMessage="Nenhum atestado carregado."
      erroGeracao="Erro ao gerar o PDF do atestado."
      sucessoMobile="Atestado gerado com sucesso!"
      alertaTitulo="⚠️ Confira o atestado antes do envio"
      alertaCorpo={
        <>
          Visualize cuidadosamente o PDF e confirme se os dados do paciente e o texto do atestado
          estão corretos. <br />
          Após a conferência, utilize o botão abaixo para enviar o atestado pelo WhatsApp:
          <strong> "Enviar pelo WhatsApp"</strong>.<br /> Lembre-se de que, uma vez enviado, não
          será possível desfazer a ação.
        </>
      }
      whatsapp={{
        celular: atestado?.CELULARPAC || prontuario?.CELULARPAC,
        paciente: {
          id: atestado?.CODPAC || prontuario?.CODPAC,
          nome: nomePaciente,
          medico: medico?.apelido,
        },
        codLaudo: atestado?.CODATESTADO,
        fileName: `Atestado_${atestado?.CODATESTADO}.pdf`,
        caption: `Olá *${nomePaciente}*, tudo bem? 😊\n\nSegue em anexo o seu *Atestado Médico*.\n\nQualquer dúvida, nossa equipe estará à disposição no setor de atendimento: (14) 3402-2700`,
      }}
    />
  );
}
